// extracted by mini-css-extract-plugin
export var filterIncDec = "_55-0";
export var leftBorder = "_55-1";
export var rightBorder = "_55-2";
export var stringInput = "_55-3";